var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSleepQualityBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100.011,
    height: 93.91,
    viewBox: "0 0 100.011 93.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(-1496 -2026.045)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M119.011,170.522v19.085h-7.763v-11l-82.161-.323v11.321H21V136.882A3.933,3.933,0,0,1,24.882,133h0a4.011,4.011,0,0,1,4.205,3.882v33.641Z",
    transform: "translate(1476 1929.348)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M57.852,192.44h84.425s1.617-13.586-4.529-14.233-60.812-9.381-60.812-2.588v9.7c0,1.294-13.909,7.44-18.114-.647C58.822,184.676,53.97,187.911,57.852,192.44Z",
    transform: "translate(1452.086 1902.255)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 6.508,
    cy: 6.508,
    rx: 6.508,
    ry: 6.508,
    transform: "translate(1512.371 2074.897)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 14.164,
    cy: 14.164,
    rx: 14.164,
    ry: 14.164,
    transform: "translate(1534.191 2027.045)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M180,45v7.44h9.7",
    transform: "translate(1368.431 1988.883)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleepQualityBlack);
export default __webpack_public_path__ + "static/media/SLEEP_QUALITY_black.ae08deaf94b366a4b0d693d8fa998040.svg";
export { ForwardRef as ReactComponent };